module.exports = __webpack_public_path__ + "static/media/tingxinliuzhixieyi.1fa6ee2f.png";